import { Button, styled } from '@material-ui/core'

export const IntegracaoButton = styled(Button)({
  width: '150px'
})
